import { Link, PhoneIcon, Spacer } from 'internalLibrary';
import styles from './Contact.module.scss';

export interface ContactPhoneProps {
  phone: string;
}

export const ContactPhone = ({ phone }: ContactPhoneProps) => {
  return (
    <Link
      className={styles.link}
      href={`tel:${phone}`}
      leftIcon={<PhoneIcon />}
    >
      <Spacer marginLeft="7px">{phone}</Spacer>
    </Link>
  );
};
